import { DSNewslettersCatalog } from 'shared-definitions/types'
import { ApiResponseNewslettersCatalog } from 'data-source/types.wp'
import { headPropsMapper } from 'data-source/mappers/headPropsMapper'
import { htmlMapper } from 'data-source/mappers/htmlMapper'
import {
  SubscriptionLinkMapper,
  subscriptionLinkMapper,
} from 'data-source/mappers/subscriptionLinkMapper'
import { subscriptionMapper } from 'data-source/mappers/subscriptionMapper'
import { PLinkMapperOpts } from './pLinkMapper'

interface CodecGetNewslettersCatalogOpts extends SubscriptionLinkMapper, PLinkMapperOpts {
  pagePath: string
}

export function codecGetNewslettersCatalog(
  raw: ApiResponseNewslettersCatalog,
  opts: CodecGetNewslettersCatalogOpts
): DSNewslettersCatalog {
  const input = raw.data
  return {
    resource: 'newsletters-catalog',
    sections: null,
    ampPagePath: null,
    head: headPropsMapper(input.head),
    meta: {
      engagementContainerId: null,
      disabledAds: false,
      dataLayer: input.head.datalayer ?? null,
      subscribeTags: ['Newsletters'],
      postId: null,
      topics: [],
      sponsor: null,
      sponsored: false,
      tags: [],
      categories: [],
    },
    pagePath: opts.pagePath,
    title: input.title,
    textHtml: htmlMapper(input.description),
    choices: input.newsletters.map(i => ({
      ...subscriptionLinkMapper(i, opts),
      ...subscriptionMapper(i, opts),
    })),
  }
}
